import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

export interface KitType {
    KitTypeId: number;
    Type: string;
    Description: string;
    TurnaroundTime: string;
    RequiredSample: string;
    TransportTempo: string;
    ProvidedReports: string;
    Available?: number;
    KitTypeCategoryId: number;
    KitTypeCatalogueId: string;
    UpdateDate: Date;
    TrfFilePath?: string;
}

interface ApiResponse {
    success: boolean;
    errCode?: string;
    errDetails?: string;
    kitTypes?: KitType[];
}

const GetKitTypes = async () => {
    const setIsLoading = useStore.getState().setIsLoading;
    const setKitTypes = useStore.getState().setKitTypes;
    const setFormError = useStore.getState().setFormError;

    setIsLoading(true);
    sendRequest(
        {
            endpoint: '/kit-type/get-all',
        },
        (data: ApiResponse) => {
            const { success, errCode, kitTypes, errDetails } = data;
            if (success) {
                setKitTypes(kitTypes);
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default GetKitTypes;
